import { ArrowUpRight, Mail, MapPin } from 'lucide-react';
import MarkdownView from '../../components/MarkdownView';
import { ErrorState, Loading } from '../../components/StatusStates';
import { useProfile } from '../../hooks/use-public';
import { useSeo } from '../../lib/seo';
import '../../styles/public.css';

export default function About() {
  useSeo({
    title: '关于',
    description: '了解本站的技术方向、技能结构与经历。',
  });
  const { data: profile, isLoading, isError, refetch } = useProfile();

  if (isLoading) {
    return (
      <div className="container content-section">
        <Loading />
      </div>
    );
  }
  if (isError || !profile) {
    return (
      <div className="container content-section">
        <ErrorState onRetry={() => refetch()} />
      </div>
    );
  }

  return (
    <div className="container about-layout">
      <div>
        <MarkdownView content={profile.bio} />

          {profile.skillGroups?.length > 0 && (
            <section style={{ marginTop: '3.5rem' }}>
              <h2 className="section-title" style={{ marginBottom: '1.75rem' }}>
                技能专长
              </h2>
              {profile.skillGroups.map((group) => (
                <div key={group.name} className="skill-group">
                  <h3 className="skill-group-title">{group.name}</h3>
                  <div className="skill-items">
                    {group.items.map((item) => (
                      <span key={item} className="skill-pill">
                        {item}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </section>
          )}

          {profile.timeline?.length > 0 && (
            <section style={{ marginTop: '3.5rem' }}>
              <h2 className="section-title" style={{ marginBottom: '1.75rem' }}>
                经历
              </h2>
              <div className="timeline">
                {profile.timeline.map((item, index) => (
                  <div key={`${item.period}-${index}`} className="timeline-item">
                    <p className="timeline-period">{item.period}</p>
                    <h3 className="timeline-title">{item.title}</h3>
                    <p className="timeline-org">{item.organization}</p>
                    {item.description && <p className="timeline-desc">{item.description}</p>}
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>

        <aside className="about-aside">
          <div className="aside-card">
            <p className="aside-heading">联系方式</p>
            {profile.email && (
              <a href={`mailto:${profile.email}`} className="footer-contact-item" style={{ color: 'var(--color-ink-soft)', marginBottom: '0.75rem' }}>
                <Mail size={15} aria-hidden="true" />
                {profile.email}
              </a>
            )}
            {profile.socials?.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item"
                style={{ color: 'var(--color-ink-soft)', marginBottom: '0.5rem' }}
              >
                {social.label}
                <ArrowUpRight size={13} aria-hidden="true" />
              </a>
            ))}
          </div>
          <div className="aside-card">
            <p className="aside-heading">当前关注</p>
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-ink-soft)', lineHeight: 1.8 }}>
              <MapPin size={14} style={{ verticalAlign: '-2px', marginRight: 4 }} aria-hidden="true" />
              工程实践、系统设计与长期的内容沉淀
            </p>
          </div>
        </aside>
    </div>
  );
}
